/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * League/tour discriminator — a league and a tour are the same entity distinguished only by this field: `tour` / `circuit` / `league` / `series` / `festival` / `other`. Null when unset on the row.
 */
export type TourType = (typeof TourType)[keyof typeof TourType];

export const TourType = {
  tour: "tour",
  circuit: "circuit",
  league: "league",
  series: "series",
  festival: "festival",
  other: "other",
} as const;
